import { permute, slugify } from "../../utils/string"

const productGalleryFormatMixin = {
    methods: {
        /**
        * Override productImages to add a slugify id and add HTTP protocol to create image link
        */
        setProductImagesData(images) {
            const httpProtocol = window.location.protocol

            let imagesIndex = 0
            while (imagesIndex < images.length) {

                const currentImageObj = images[imagesIndex]

                currentImageObj.id = slugify(currentImageObj.rawId.trim())
                currentImageObj.preview = httpProtocol + currentImageObj.preview
                currentImageObj.image = httpProtocol + currentImageObj.image

                imagesIndex++
            }
        },

        /**
        * Set new array of product variants
        */
         setProductVariantsData(variants, productImages) {
            const newVariantsModelArr = []
            let variantsIndex = 0

            // Prepare array for images used by variants
            let usedImages = []

            while (variantsIndex < variants.length) {
                // Get current variant
                const { id } = variants[variantsIndex]

                // New object model
                const newVariantObj = {
                    id,
                    optionsImagesIds: [],
                    images: []
                }

                // 1 - Create array of all options combinations slugs
                const optionsValues =  variants[variantsIndex].options.map((value, index) => {
                    return slugify(value.trim())
                })
                const optionsCombinations = permute(optionsValues)
                const optionsCombinationsIds = optionsCombinations.map((arr, index) => {
                    return slugify(arr.join('-').trim())
                })
                newVariantObj.optionsImagesIds = [...optionsValues, ...optionsCombinationsIds]

                // 2 - add variant images
                newVariantObj.images = productImages.filter(images => newVariantObj.optionsImagesIds.indexOf(images.id) != -1);

                // 3 - store images used
                if (newVariantObj.images.length) {
                    usedImages = [...usedImages, ...newVariantObj.images]
                }

                // 4 - then store new object
                newVariantsModelArr.push(newVariantObj)

                variantsIndex++
            }

            // Remove duplicates
            const uniqUsedImages = [...new Set(usedImages)]

            // Get unused images : it's the common images
            const onlyInA = productImages.filter(this.compareImagesArr(uniqUsedImages));
            const onlyInB = uniqUsedImages.filter(this.compareImagesArr(productImages));
            const unusedImages = onlyInA.concat(onlyInB)

            // Then add common images for each variants
            if (unusedImages.length) {
                newVariantsModelArr.forEach((variant) => {
                    variant.images = [...variant.images, ...unusedImages]
                })
            }

            return newVariantsModelArr
        },

        /**
        * Compare image utils
        */
         compareImagesArr(imagesArr) {
            return function(current){
                return imagesArr.filter(function(image){
                return image.id == current.id
                }).length == 0;
            }
        }
    }
}

export default productGalleryFormatMixin;
